<template>
  <div>
    <my-asidebar v-bind:active-tab="'port'"> </my-asidebar>

    <section class="dashboard-area">
      <top-bar></top-bar>
      <div class="dashboard-content-wrap">
        <div class="dashboard-bread dashboard--bread dashboard-bread-2">
          <div class="container-fluid">
            <div class="row align-items-center">
              <div class="col-lg-6">
                <div class="breadcrumb-content">
                  <div class="section-heading">
                    <h2 class="sec__title font-size-30 text-white">Liman</h2>
                  </div>
                </div>
              </div>
              <div class="col-lg-6">
                <div class="breadcrumb-list text-right">
                  <ul class="list-items">
                    <li><a :href="basePath" class="text-white">Anasayfa</a></li>
                    <li><a :href="basePath+'/ports'" class="text-white">Liman</a></li>
                    <li>Detay</li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
        <port-detail></port-detail>
      </div>
    </section>

  </div>
</template>

<script>
import PortDetail from "../component/port/PortDetail";
import MyAsidebar from "../component/common/MyAsidebar";
import TopBar from "../component/common/TopBar";

export default {
  name: "PortDetailPage",
  components: {TopBar, MyAsidebar,  PortDetail},
  computed:{
    basePath:{
      get(){
        return this.$store.getters.getBasePath
      }
    },
    panelRights:{
      get(){
        return this.$store.getters.getPanelRightsMap;
      }
    }
  },
  mounted() {
    if(!this.panelRights["PANEL_PAGE_PORT_DETAIL"]) this.$router.push("/");

    if(this.$route.params.id !== undefined && this.$route.params.id !== 'new') {
      this.$store.dispatch("loadPort",this.$route.params.id)
    }else{
      this.$nextTick(()=>{
        this.$store.commit("setPort",{id:null})
      })
    }
    this.$store.dispatch("loadCruise").then(()=>{
      this.$store.dispatch("loadRoomList")
    });
  }
}
</script>

<style scoped>

</style>